import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const BoatLocation = ({ boatLocation }: SpecProps<"boat_location">) => {
  const { i18n } = useLingui();
  if (!boatLocation) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.boat_location",
    message: "Boat location",
    comment: "Field for 'boat location' in ad specification",
  });
  return <FieldValuePair field={field} value={boatLocation} />;
};
